module.exports = __webpack_public_path__ + "assets/img/组 541@2x.19968b5d.png";